/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Pelecard
 */
export class Pelecard {
    /**
     *
     * @type {string}
     * @memberof Pelecard
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Pelecard
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Pelecard
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Pelecard
     */
    username: string;
    /**
     *
     * @type {string}
     * @memberof Pelecard
     */
    password: string;
    /**
     *
     * @type {string}
     * @memberof Pelecard
     */
    tokenBillingTerminal: string;
    /**
     *
     * @type {string}
     * @memberof Pelecard
     */
    tokenCreationTerminal: string;
    /**
     *
     * @type {boolean}
     * @memberof Pelecard
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Pelecard
     */
    autoApprove: boolean;
}
